import { render, staticRenderFns } from "./Layout1.vue?vue&type=template&id=383e24b6&scoped=true"
import script from "./Layout1.vue?vue&type=script&lang=js"
export * from "./Layout1.vue?vue&type=script&lang=js"
import style0 from "./Layout1.vue?vue&type=style&index=0&id=383e24b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383e24b6",
  null
  
)

export default component.exports